/* @jsxImportSource react */

import { SWRConfig } from 'swr';

import config from '@packages/config';
import type { Locale } from '@packages/config';
import type { Device } from '@packages/shared/src/utils/types';
import { ResponsiveNavigationLoaderClient } from './ResponsiveNavigationLoader.Client';
import { getNavigationDataEndpoint } from '../getNavigationDataEndpoint';
import { fetchRequiredStaticJson } from '../../api';

/**
 * RSC data fetching wrapper around {@link ResponsiveNavigationLoaderClient}
 */
export const ResponsiveNavigationLoaderServer = async ({
  locale,
  device,
}: {
  device: Device;
  locale: Locale;
}) => {
  const deploymentEnv = process.env.DEPLOYMENT_ENV;
  const {
    clientId,
    navigation: { loadSliced, dataBucket },
  } = config;

  const navEndpoint = getNavigationDataEndpoint(
    dataBucket,
    clientId,
    device === 'desktop' ? 'web' : 'mob',
    locale,
    loadSliced,
    deploymentEnv,
  );

  const data = await fetchRequiredStaticJson(navEndpoint, {
    componentName: 'ResponsiveNavigationLoaderServer',
  });

  return (
    <SWRConfig value={{ fallback: { [navEndpoint]: data, deploymentEnv } }}>
      <ResponsiveNavigationLoaderClient device={device} />
    </SWRConfig>
  );
};
